import { FaLinkedinIn, FaYoutube } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white  mt-auto border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-6">

        <div className="flex flex-col md:flex-row items-center justify-between gap-4">

          {/* Copyright */}
          <p className="text-sm text-slate-300">
            © 2026 Bytecs Technologies Pvt. Ltd. All Rights Reserved.
          </p>

          {/* Social Icons */}
          <div className="flex items-center gap-4">
            <span className="text-sm text-slate-400">
              Follow Us:
            </span>

            <a
              href="https://www.linkedin.com/company/bytecstechnologies/?originalSubdomain=in"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-full bg-slate-800 hover:bg-blue-600 flex items-center justify-center transition-all duration-300 hover:scale-110"
            >
              <FaLinkedinIn size={16} />
            </a>

           <a
              href="https://www.youtube.com/embed/FC8zG-OcH7A"
              target="_blank"
              class="w-8 h-8 rounded-full bg-slate-800 hover:bg-red-600 flex items-center justify-center transition duration-300"
            >
              <FaYoutube size={16} />
            </a>
          </div>

        </div>

      </div>
    </footer>
  );
};

export default Footer;